import { DATA_STORE_JOB } from '../types';

const initialState = {
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DATA_STORE_JOB: {
      const { id } = action.payload;
      // eslint-disable-next-line no-param-reassign
      state.data[id] = action.payload;

      return {
        ...state,
      };
    }
    default:
      return state;
  }
};
